<script>
import _ from 'lodash';

export default {
  name: 'AppTabs',
  props: [
    'activeTabProp' // can be a string or a number (!)
  ],
  data() {
    return {
      activeTabIndex: 0, // always a number
      activeTabName: '' // always a string
    };
  },
  computed: {
    tabs() {
      return this.$children || [];
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index || 0;
      this.activeTabName = this.tabs[this.activeTabIndex].name || '';

      this.tabs.forEach((tab, i) => {
        tab.isActive = i === index;
        if (tab.to) {
          tab.href = _.get(this.$router.resolve(tab.to), 'href');
        }
      });

      let activeTabProp = _.isString(this.activeTabProp) ? this.activeTabName : this.activeTabIndex;
      this.$emit('activeTabChanged', activeTabProp);
    },
    changeTabByOutsideProp() {
      if (_.isString(this.activeTabProp)) {
        let selectedTab = this.tabs.find((tab) => tab.name === this.activeTabProp);
        let selectedTabIndex = this.tabs.indexOf(selectedTab);
        this.activeTabIndex = selectedTabIndex >= 0 ? selectedTabIndex : 0;
      } else {
        this.activeTabIndex = this.activeTabProp || 0;
      }
    }
  },

  mounted() {
    this.changeTabByOutsideProp();
    this.selectTab(this.activeTabIndex);
  },

  watch: {
    activeTabProp() {
      this.changeTabByOutsideProp();
    }
  }
};
</script>

<template>
  <div class="app-tabs">
    <nav class="nav" :class="'selected-tab-' + activeTabIndex">
      <a
        v-for="(tab, index) in tabs"
        :href="tab.href || null"
        :key="index"
        @click="selectTab(index)"
        :class="{ active: activeTabIndex === index }"
        class="nav-item"
        :style="{ 'max-width': 100 / tabs.length + '%' }"
      >
        {{ tab.title }}
      </a>
      <span
        class="tab-line"
        :style="{
          width: 100 / (tabs.length || 1) + '%',
          left: (100 * this.activeTabIndex) / (tabs.length || 1) + '%'
        }"
      ></span>
    </nav>

    <slot />
  </div>
</template>

<style lang="scss" scoped>
.nav {
  position: relative;
  display: flex;
  justify-content: space-between;
  color: var(--purple-light);
  border-bottom: 1px solid var(--purple-light);

  .nav-item {
    padding: 6px 12px;
    flex: 1;
    text-align: center;
    font-size: 13px;
    cursor: pointer;
    user-select: none;

    &.active {
      color: var(--primary-color);
      font-weight: 600;
    }
  }

  .tab-line {
    background: var(--primary-color);
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: left 0.2s ease-out;
  }
}

// ::v-deep .app-tab {
// }
</style>
